import React from "react";

const BannerCTA =({data, targetRef}) => {
  const scrollToSection = () => {
    if (targetRef && targetRef.current) {
      const headerOffset = 120;
      const elementPosition = targetRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };
  return (
    <section className="bg-[#E3A003] py-[100px] sm:py-20 md:px-6">
      <div className="max-w-[1100px] mx-auto bg-white rounded-full sm:rounded-3xl shadow-lg flex sm:flex-col items-center justify-between px-6 sm:px-3 py-2 gap-4 sm:mx-3">
        
        {/* Left Content */}
        <div className="sm:text-left w-4/6 sm:w-full">
          <h3 className="text-lg font-medium text-[#1A1A1A] mb-xsp">
            {data.title}
          </h3>
          <p className="text-gray-600 text-base">
            {data.description}
          </p>
        </div>

        {/* Right Button */}
        <div>
        <button
          className="bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C] text-white px-5 py-2 rounded-full text-sm font-normal whitespace-nowrap"
          onClick={(e) => {
            e.stopPropagation(); 
            scrollToSection();
          }}
        >
          {data.button.label}
        </button>
        </div>
      </div>
    </section>
    
  );
}
export default BannerCTA; 
